import React from 'react';

import { Container, NoResults, UserCellAvatar, UserCellName, UserMentionRow, StyledCircularProgress } from './styles';
import { AutocompleteMentionProps } from './types';

const AutocompleteMention: React.FunctionComponent<AutocompleteMentionProps> = ({
  onSelectedUser,
  selected,
  users,
  loading,
}): React.ReactElement => {
  const rowRefs = React.useRef<Array<HTMLDivElement | null>>([]);

  React.useEffect(() => {
    rowRefs.current = rowRefs.current.slice(0, users.length);
  }, [users]);

  React.useEffect(() => {
    if (rowRefs.current[selected]) {
      rowRefs.current[selected]?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  }, [selected]);

  return (
    <Container>
      {loading ? (
        <UserMentionRow>
          <StyledCircularProgress />
        </UserMentionRow>
      ) : (
        <>
          {users.length === 0 && (
            <UserMentionRow>
              <NoResults>No Results</NoResults>
            </UserMentionRow>
          )}
          {users.map((user, index) => (
            <UserMentionRow
              key={user.uuid}
              selected={index === selected}
              onMouseDown={() => onSelectedUser(index)}
              ref={(el) => {
                rowRefs.current[index] = el;
              }}
            >
              <UserCellAvatar name={user.name} size="small" />
              <UserCellName>
                {user.name} ({user.email})
              </UserCellName>
            </UserMentionRow>
          ))}
        </>
      )}
    </Container>
  );
};

export default AutocompleteMention;
